import React, { useRef, useState } from 'react';

import PropTypes from 'prop-types';
import Box from '@tds/core-box';
import Button from '@tds/core-button';
import Spinner from '@tds/core-spinner';
import DimpleDivider from '@tds/core-dimple-divider';

import request from '../../../../utils/request';
import { useLocaleContext } from '../../../../context/LocaleContext';
import { ErrorMessage } from '../../../../form/fields/css';

import EN from '../../../../../EN.json';
import FR from '../../../../../FR.json';

const FileUpload = ({ addFileToList, orderId }) => {
  const locale = useLocaleContext();
  const {
    general: {
      fileSelectError,
      fileUploadingError,
      fileSizeError,
      uploading,
      uploadLabel
    }
  } = locale === 'en-US' ? EN : FR;
  const [selectedFile, setSelectedFile] = useState();
  const [showError, setShowError] = useState({ isVisible: false, message: '' });
  const [isUploading, setIsUploading] = useState(false);
  const inputRef = useRef();

  const validateFileSize = file => {
    const fileSize = file.size / 1024 / 1024;
    if (fileSize > 5) {
      setShowError({
        isVisible: true,
        message: fileSizeError.replace('**SIZE**', 5)
      });
      inputRef.current.value = '';
      return false;
    }
    return true;
  };

  const onFileSelect = e => {
    const file = e.target.files[0];

    if (!validateFileSize(file)) return;

    setShowError({ isVisible: false, message: '' });
    setSelectedFile(file);
  };

  const uploadFile = () => {
    const formData = new FormData();
    formData.append('file', selectedFile);
    formData.append('typeId', 0);
    return request.post(`/orders/${orderId}/upload-file`, formData);
  };

  const onFileUpload = async () => {
    if (!selectedFile) {
      setShowError({
        isVisible: true,
        message: fileSelectError
      });
      return;
    }
    setIsUploading(true);
    try {
      const result = await uploadFile();
      if (result) {
        const {
          data: { orderFiles }
        } = result;
        addFileToList(orderFiles);
        setIsUploading(false);
        setSelectedFile(null);
        inputRef.current.value = '';
      }
    } catch (error) {
      setShowError({
        isVisible: true,
        message: fileUploadingError
      });
      setIsUploading(false);
      throw error;
    }
  };

  return (
    <>
      <DimpleDivider />
      <Box between={2}>
        <Box>
          <input
            type="file"
            name="uploadFile"
            onChange={onFileSelect}
            accept=".pdf"
            ref={inputRef}
          />
        </Box>
        <Box between={4} inset={2} />
        <Box>
          <Spinner label={uploading} size="small" spinning={isUploading} inline>
            <Button onClick={onFileUpload}>{uploadLabel}</Button>
          </Spinner>
          {showError.isVisible && (
            <ErrorMessage>{showError.message}</ErrorMessage>
          )}
        </Box>
      </Box>
    </>
  );
};

FileUpload.propTypes = {
  addFileToList: PropTypes.func.isRequired,
  orderId: PropTypes.number.isRequired
};

export default FileUpload;
